import { getUserId } from 'app/auth/selectors';
import { getProjectUsers } from 'app/collab/selectors';
import { useSelector } from 'react-redux';

export function useProjectUsers() {
  const projectUsers = useSelector(getProjectUsers);
  const currentUserId = useSelector(getUserId);

  return {
    users: Object.values(projectUsers).filter((user) => user.id !== currentUserId)
  };
}
